<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'app',
        metaInfo: function() {
            return {
                title: 'Japan Heritage Official Site | Stories and travel information | JNTO',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Japan Heritage Official Site',
                    },
                    {
                        vmid: 'keywords',
                        name: 'keywords',
                        content: 'Agency for Cultural Affairs,Japan,Japan Heritage,temple,shrine,heritage,traditional arts,' +
                            'castle,armor,armour,cultural asset,historic site,scenic spot,tradition,history,photo,footage,' +
                            'video,sightseeing,tourism,access,accommodation,hotel,hotel,ryokan,activities',
                    },
                    {
                        vmid: 'og-title',
                        property: 'og:title',
                        content: 'Japan Heritage Official Site | Stories and travel information | JNTO',
                    },
                    {
                        vmid: 'og-type',
                        property: 'og:type',
                        content: 'website',
                    },
                    {
                        vmid: 'og-description',
                        property: 'og:description',
                        content: 'Japan Heritage ties together historical sites, shrines, temples, traditional arts, ' +
                            'castles, armor, and other cultural assets. Find photos, videos, tourist information, and more.',
                    },
                    {
                        vmid: 'og-url',
                        property: 'og:url',
                        content: location.href,
                    },
                    {
                        vmid: 'og-image',
                        property: 'og:image',
                        content: 'https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/Top/index_mainimage.jpg',
                    },
                    {
                        vmid: 'og-site-name',
                        property: 'og:site_name',
                        content: 'Japan National Tourism Organization (JNTO)',
                    },
                    {
                        vmid: 'og-locale',
                        property: 'og:locale',
                        content: 'en',
                    }
                ]
            }
        },
    }
</script>

<style src="./styles/style.scss" lang="scss"></style>
